// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];

export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};

export const OPEN_TYPES = {
  FAB_OPEN: 'FAB_OPEN',
  FAB_CLOSE: 'FAB_CLOSE',
  DEFAULT_MINIMIZED: 'DEFAULT_MINIMIZED',
  DEFAULT_OPEN: 'DEFAULT_OPEN',
  QUESTION_OPEN: 'QUESTION_OPEN',
  UNKNOWN: 'unknown'
};

export const MAGIC_APRON_ASSISTANT_ORIGIN = 'maa';
